/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-bff.envdevel.com/v3/api-docs
*/


export type MarketCountryCode = typeof MarketCountryCode[keyof typeof MarketCountryCode];


export const MarketCountryCode = {
  AD: 'AD',
  AE: 'AE',
  AT: 'AT',
  BE: 'BE',
  BS: 'BS',
  BZ: 'BZ',
  CA: 'CA',
  CH: 'CH',
  CL: 'CL',
  CO: 'CO',
  CR: 'CR',
  CZ: 'CZ',
  DE: 'DE',
  DK: 'DK',
  ES: 'ES',
  FR: 'FR',
  GR: 'GR',
  HR: 'HR',
  HU: 'HU',
  IE: 'IE',
  IT: 'IT',
  KY: 'KY',
  LI: 'LI',
  LU: 'LU',
  MF: 'MF',
  MG: 'MG',
  MU: 'MU',
  MX: 'MX',
  NL: 'NL',
  PA: 'PA',
  PL: 'PL',
  PT: 'PT',
  TC: 'TC',
  US: 'US',
  UY: 'UY',
  VG: 'VG',
  ZA: 'ZA',
  'private-office': 'private-office',
} as const;
